'use client';

import { NOT_FOUND } from '@/app/lib/constants/literals';
import { Button } from '@radix-ui/themes';
import Link from 'next/link';
import { useEffect } from 'react';

const NotFoundClient = () => {
  useEffect(() => {
    document.title = NOT_FOUND; // ← Принудительно обновляем title, баг Next.js
  }, []);

  return (
    <Link
      href='/'
      passHref
    >
      <Button>Вернуться</Button>
    </Link>
  );
};

export default NotFoundClient;
